import { NgModule } from "@angular/core";
import { DividerPanelComponent } from "./divider-panel.component";

@NgModule({
  declarations: [DividerPanelComponent],
  exports: [DividerPanelComponent],
})
export class DividerPanelModule {}
